"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioList = exports.PermissionsList = exports.Container = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
exports.Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
exports.PermissionsList = styled_components_1.default.div `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin: 0.5rem;
`;
exports.RadioList = styled_components_1.default.div `
  margin-left: 0.5rem;
`;
